import React from 'react';
import { Button } from '@mui/material';

export const LoadMoreButton = ({
  onClick,
  loading,
}: {
  onClick: () => void;
  loading: boolean;
}) => {
  return (
    <Button
      variant="contained"
      color="secondary"
      onClick={onClick}
      disabled={loading}
      sx={{
        opacity: loading ? 0.9 : 1,
        mt: 2,
        mb: 2,
        px: 4,
        borderRadius: '100px',
      }}
    >
      {loading ? 'Loading more...' : 'Load More'}
    </Button>
  );
};
